import { useState, type FormEvent } from "react";
import { ApiError } from "../api/client";
import { useSession } from "../state/session";

export function LoginScreen({ surfaceHint }: { surfaceHint: string }) {
  const { signIn } = useSession();

  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setBusy(true);

    try {
      await signIn(login, password);
      // Экран входа показывается поверх исходного адреса, не меняя его, —
      // поэтому после входа сотрудник остаётся ровно там, куда шёл.
    } catch (cause) {
      if (cause instanceof ApiError && cause.status === 429) {
        setError("Слишком много попыток входа. Подождите немного.");
      } else {
        setError(cause instanceof Error ? cause.message : "Не удалось войти");
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="brand">
          <span className="brand-mark">ПФ</span>
          <span>
            Парк Фуд
            {/* Подпись говорит, куда именно вошёл сотрудник: экраны разъехались
                по поддоменам, и перепутать адрес легко. */}
            <small>вход для {surfaceHint}</small>
          </span>
        </div>

        <label className="field">
          <span>Логин</span>
          <input
            name="login"
            autoComplete="username"
            autoFocus
            required
            value={login}
            onChange={event => setLogin(event.target.value)}
          />
        </label>

        <label className="field">
          <span>Пароль</span>
          <input
            name="password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={event => setPassword(event.target.value)}
          />
        </label>

        {error ? <p className="form-error">{error}</p> : null}

        <button className="btn btn-primary btn-xl btn-block" type="submit" disabled={busy}>
          {busy ? "Проверяем…" : "Войти"}
        </button>
      </form>
    </div>
  );
}
